import { Chip } from '@truepill/react-capsule'
import { Bell } from 'react-feather'

const BellIcon = ({ size }: { size?: string | number }) => {
  return (
    <Chip state="warning">
      <Bell aria-hidden size={size} />
    </Chip>
  )
}

export default BellIcon
